import * as React from 'react';
import { BottomSheetAnimated } from './BottomSheetAnimated';
import { BottomSheetAnimatedWrapperProps } from '../schema/BottomSheetAnimatedProps';
import { FocusTrapZone } from 'focus-trap-zone';
import { getBottomSheetAnimatedDivId } from '../utils/bottomSheetAnimatedDivUtils';
import { preventModalScroll } from 'prevent-modal-scroll';

const ModalScrollPreventedBottomSheetAnimated = preventModalScroll(
    BottomSheetAnimated,
    (component: any): HTMLDivElement => component
);

export const BottomSheetAnimatedInstance: React.FC<BottomSheetAnimatedWrapperProps> = React.forwardRef(
    (props: BottomSheetAnimatedWrapperProps, ref?: React.RefObject<any>) => {
        const { isScrollable } = props;
        const BottomSheetInstance = isScrollable
            ? BottomSheetAnimated
            : ModalScrollPreventedBottomSheetAnimated;

        return <BottomSheetInstance {...props} ref={ref} />;
    }
);
export const BottomSheetAnimatedWrapper: React.FC<BottomSheetAnimatedWrapperProps> = React.forwardRef(
    (props: BottomSheetAnimatedWrapperProps, ref?: React.RefObject<any>) => {
        const { id, elementToFocusOnClose, elementToFocusOnOpen } = props;

        return (
            <FocusTrapZone
                id={getBottomSheetAnimatedDivId(id)}
                focusOnClose={elementToFocusOnClose}
                focusOnOpen={elementToFocusOnOpen}>
                <BottomSheetAnimatedInstance {...props} ref={ref} />
            </FocusTrapZone>
        );
    }
);

export default BottomSheetAnimatedWrapper;
